import { MouseEvent, useState } from 'react';
import { trackEvent } from '~/api/analytics';
import { Button, Center, Icon, Pressable } from '~/commonComponents';
import Portal from '~/commonComponents/Portal';
import ShareIcon from '~/images/share-icon.svg';
import { IShift } from '~/models';
import { InviteProfessionalPopup } from './Popup';

interface IProps {
  shift: IShift;
  buttonText?: string;
  isRefetchJob?: boolean;
  size?: 'icon' | 'default';
}

export const InviteProfessional = ({
  shift,
  buttonText = 'Invite Professionals',
  isRefetchJob = true,
  size = 'default',
}: IProps) => {
  const [isInvitePopupOpen, setInvitePopupOpen] = useState(false);

  const handleInviteClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setInvitePopupOpen(true);
  };

  return (
    <>
      <Center width="100%" height="100%">
        {size === 'default' ? (
          <Button Icon={ShareIcon} text={buttonText} onClick={handleInviteClick} />
        ) : (
          <Pressable onPress={handleInviteClick}>
            <Icon name="share" size={24} />
          </Pressable>
        )}
      </Center>
      <Portal>
        <div onClick={(e) => e.stopPropagation()}>
          <InviteProfessionalPopup
            isOpen={isInvitePopupOpen}
            isRefetchJob={isRefetchJob}
            jobId={shift?.id}
            profession={shift?.profession}
            onClose={() => setInvitePopupOpen(false)}
            onTrackEvent={() => {
              trackEvent(`Shifts - Open tab - Invite Icon Clicked`, {
                job: {
                  jobId: shift.id,
                  profession: shift.profession,
                  rate: shift.rate,
                  shiftId: (shift as any).shiftId,
                  totalHours: (shift as any).totalHours,
                  local_date: shift.local_date,
                  local_end_time: shift.local_end_time,
                  local_start_time: shift.local_start_time,
                  local_timezone: (shift as any).local_timezone,
                  lunch_break_time: shift.lunch_break_time,
                  lunch_final_break_time: shift.lunch_final_break_time,
                  specialty: shift.specialty,
                },
              });
            }}
          />
        </div>
      </Portal>
    </>
  );
};
